import { observable } from 'mobx';
import { MaterialViewModel } from 'chaika-types';

export class MaterialsStore {
    public static Name = 'materialsStore' as const;

    @observable public materials: MaterialViewModel[] = [];
}

export const materialsStore = new MaterialsStore();
